import React, { useState, useEffect ,useRef} from "react";
import AxiosInstance from "../AxiosInstance";
import { useNavigate } from "react-router-dom";
import { ArrowLeftCircle } from "react-bootstrap-icons";
import { Row,Col,Button } from "react-bootstrap";
import ToastNotification from "../ToastNotification";
import { useParams } from 'react-router-dom';
import Layout from "./Layout";
import PersonalDetails from "./PersonalDetails";
import WorkDetails from "./WorkDetails";
import Address from "./Address";
import ExitReason from "./ExitReason";

const EmployeeEdit = () => {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [departments, setDepartments] = useState([]);
  const [employeeTypes, setEmployeeTypes] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [managers, setManagers] = useState([]);
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [imageName, setImageName] = useState("");
  const toastRef = useRef(null); // Create a ref for the toast
  const [exitReasons, setExitReasons] = useState([]); // Store exit reasons
  const [activeTab, setActiveTab] = useState("personal");
  const [newEmployee, setNewEmployee] = useState({
  first_name: "",
  middle_name: "",
  last_name: "",
  email: "",
  designation: "",
  department: "",
  employee_type: "",
  role: "employee",
  manager: "",
  date_of_birth: "",
  gender: "",
  date_of_join: "",
  phone_number: "",
  image_profile: "",
  last_working_day: "",
  exit_reason_id: null,
  //Permanent address
  permanent_building_no: "",
  permanent_locality: "",
  permanent_landmark: "",
  permanent_city: "",
  permanent_state: "",
  permanent_pincode: "",
  permanent_country: "",
  // Communication address
  communication_building_no: "",
  communication_locality: "",
  communication_landmark: "",
  communication_city: "",
  communication_state: "",
  communication_pincode: "",
  communication_country: "",
});
  const imageUrl = process.env.REACT_APP_BASE_URL+'/uploads/';
  // Fetch departments
  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const response = await AxiosInstance.get("/common/departments");
        setDepartments(response.data);
      } catch (error) {
       toastRef.current?.showToast("Error fetching departments:", "danger");
      }
    };
    fetchDepartments();
  }, []);

  // Fetch employee types
  useEffect(() => {
    const fetchEmployeeTypes = async () => {
      try {
        const response = await AxiosInstance.get("/common/employeeType");
        setEmployeeTypes(response.data);
      } catch (error) {
       toastRef.current?.showToast("Error fetching employee types:", "danger");
      }
    };
    fetchEmployeeTypes();
  }, []);

  useEffect(() => {
    const fetchDesignations = async () => {
      try {
        const response = await AxiosInstance.get("/common/designations");
        setDesignations(response.data);
      } catch (error) {
        toastRef.current?.showToast("Error fetching designations:", "danger");
      }
    };
    fetchDesignations();
  }, []);  

   // Fetch managers
   useEffect(() => {
    const fetchManagers = async () => {
      try {
        const response = await AxiosInstance.get("/common/managers");
        setManagers(response.data);
      } catch (error) {
        toastRef.current?.showToast("Error fetching managers:", "danger");
      }
    };
    fetchManagers();
  }, []);

 useEffect(() => {
  if (userId) {
    const fetchUserDetails = async () => {
      try {
        const response = await AxiosInstance.get(`/common/api/user-details/${userId}`);
        const data = response.data;

        const cleanField = (value) => {
          return value === "Not provided" ? "" : value;
        };

        setNewEmployee({
          first_name: cleanField(data.first_name),
          middle_name: cleanField(data.middle_name),
          last_name: cleanField(data.last_name),
          email: cleanField(data.email),
          date_of_birth: cleanField(data.date_of_birth),
          gender: cleanField(data.gender),
          date_of_join: cleanField(data.date_of_join),
          // Permanent address
          permanent_building_no: cleanField(data.permanent_building_no),
          permanent_locality: cleanField(data.permanent_locality),
          permanent_landmark: cleanField(data.permanent_landmark),
          permanent_city: cleanField(data.permanent_city),
          permanent_state: cleanField(data.permanent_state),
          permanent_pincode: cleanField(data.permanent_pincode),
          permanent_country: cleanField(data.permanent_country),
          // Communication address
          communication_building_no: cleanField(data.communication_building_no),
          communication_locality: cleanField(data.communication_locality),
          communication_landmark: cleanField(data.communication_landmark),
          communication_city: cleanField(data.communication_city),
          communication_state: cleanField(data.communication_state),
          communication_pincode: cleanField(data.communication_pincode),
          communication_country: cleanField(data.communication_country),
          department: cleanField(data.department_name),
          designation: cleanField(data.designation_name),
          manager: `${cleanField(data.manager_first_name)} ${cleanField(data.manager_last_name)}`,
          employee_type: cleanField(data.employee_type),
          phone_number: cleanField(data.phone_number),
          last_working_day: cleanField(data.last_day),
          exit_reason_id: data.exit_reason_id, // keep as-is if numeric
        });

        if (data.image_profile && data.image_profile !== "Not Provided") {
          setImagePreview(`${imageUrl}${data.image_profile}`);
          setImageName(data.image_profile);
        }

      } catch (error) {
       toastRef.current?.showToast('Error fetching user data:', "danger");
      }
    };

    fetchUserDetails();
  }
}, [userId, imageUrl]);

  useEffect(() => {
    const fetchExitReasons = async () => {
      try {
        const response = await AxiosInstance.get("/common/exitReasons");
        setExitReasons(response.data);
      } catch (error) {
       toastRef.current?.showToast("Error fetching exit reasons:", "danger");
      }
    };
    fetchExitReasons();
  }, []);  

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      let imageFileName = "";
  
      // Upload image if selected
      if (imageFile) {
        const formData = new FormData();
        formData.append("image", imageFile);
  
        const uploadRes = await AxiosInstance.post("/admin/upload-image", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
  
        imageFileName = uploadRes.data.filename;
      }
  
      const employeeData = {
        ...newEmployee,
        image_profile: imageFileName || imageName,
        last_day: newEmployee.last_working_day,
      };      
      let response;
      if (userId)  {
        // If user_id is present → Update
        response = await AxiosInstance.put(`/admin/update-user/${userId}`, employeeData);
        toastRef.current?.showToast("Employee details updated successfully!", "success");
      } else {
        // If no user_id → Create new employee
        response = await AxiosInstance.post("/admin/user", employeeData);
        const { username } = response.data;
        toastRef.current?.showToast(`Employee added successfully with username: ${username || "N/A"}`, "success");
      }
  
      // Wait 3 seconds before navigating
      setTimeout(() => {
        navigate("/employee-list");
      }, 3000);
    } catch (error) {
      const errorMsg = error.response?.data?.message || "Error submitting employee data.";
      toastRef.current?.showToast(errorMsg, "danger");
    }
  };
  
  return (
    <Layout>
      <div className="container mt-4">
        <h2>{userId ? "Edit Employee" : "Add New Employee"}</h2>

        <div className="mb-3">
          <Button className="btn btn-secondary" onClick={() => navigate(-1)}>
            <ArrowLeftCircle />
          </Button>
        </div>

        <form onSubmit={handleSubmit}>
          {/* 📌 TAB BUTTONS */}
          <Row>
            <Col xs={12}>
              <ul className="nav nav-tabs flex-column flex-md-row">
                {[
                  { key: "personal", label: "Personal Details" },
                  { key: "work", label: "Work Details" },
                  { key: "address", label: "Address" },
                  { key: "exit", label: "Exit Reason" }
                ].map((tab) => (
                  <li className="nav-item col-12 col-md-auto p-1" key={tab.key}>
                    <button
                      className={`nav-link w-100 ${activeTab === tab.key ? "active" : "text-dark"}`}
                      onClick={(e) => {
                        e.preventDefault();
                        setActiveTab(tab.key);
                      }}
                    >
                      {tab.label}
                    </button>
                  </li>
                ))}
              </ul>
            </Col>
          </Row>

          {/* 🔍 TABBED CONTENT */}
          <div className="card p-4">
            {activeTab === "personal" && (
              <PersonalDetails
                newEmployee={newEmployee}
                setNewEmployee={setNewEmployee}
                imageFile={imageFile}
                setImageFile={setImageFile}
                imagePreview={imagePreview}
                setImagePreview={setImagePreview}
                imageName={imageName}
                setImageName={setImageName}
              />
            )}
            {activeTab === "work" && (
              <WorkDetails
                newEmployee={newEmployee}
                setNewEmployee={setNewEmployee}
                departments={departments}
                designations={designations}
                managers={managers}
                employeeTypes={employeeTypes}
              />
            )}
            {activeTab === "address" && (
              <Address
                newEmployee={newEmployee}
                setNewEmployee={setNewEmployee}
              />
            )}
            {activeTab === "exit" && (
              <ExitReason
                newEmployee={newEmployee}
                setNewEmployee={setNewEmployee}
                exitReasons={exitReasons}
              />
            )}
          </div>

          <div className="text-end mt-3">
            <Button type="submit" className="btn btn-primary">
              Save Changes
            </Button>
          </div>
        </form>
      </div>
        <ToastNotification ref={toastRef} />
    </Layout>
  );
};
export default EmployeeEdit;  